// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px) and (min-width: 601px)";
var _4 = "wrapper-3bHGd";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet_only", _4 as "wrapper" }
export default { "__esModule": _1, "mobile": _2, "tablet_only": _3, "wrapper": _4 }
